<template>
	<div>
		<page-header></page-header>
		<div class="jumbotron jumbotron-fluid">
			<div class="container">
				<h1 class="display-4">{{"404 Not Found"}}</h1>
				<p class="lead">
					{{"The requested page or resource could not be located"}}
				</p>
			</div>
		</div>
		<page-footer class="fixed-bottom"></page-footer>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	setup()
	{
		return {
		};
	},
});
</script>

<style scoped>
</style>
